export const IS_IN_MODAL = Symbol('is-in-modal');
